/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPriorCurrentYearAmt
 */
export interface ExecRiskPriorCurrentYearAmt {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPriorCurrentYearAmt
     */
    PriorYearAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPriorCurrentYearAmt
     */
    CurrentYearAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskPriorCurrentYearAmt interface.
 */
export function instanceOfExecRiskPriorCurrentYearAmt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPriorCurrentYearAmtFromJSON(json: any): ExecRiskPriorCurrentYearAmt {
    return ExecRiskPriorCurrentYearAmtFromJSONTyped(json, false);
}

export function ExecRiskPriorCurrentYearAmtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPriorCurrentYearAmt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'PriorYearAmt': !exists(json, 'PriorYearAmt') ? undefined : json['PriorYearAmt'],
        'CurrentYearAmt': !exists(json, 'CurrentYearAmt') ? undefined : json['CurrentYearAmt'],
    };
}

export function ExecRiskPriorCurrentYearAmtToJSON(value?: ExecRiskPriorCurrentYearAmt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PriorYearAmt': value.PriorYearAmt,
        'CurrentYearAmt': value.CurrentYearAmt,
    };
}

